import React, { FC } from 'react';
import styled from 'styled-components';
import { FormTemplate } from 'api/form/types';
import { BackgroundImage } from './background-image';
import { ColorThemesList } from './color-themes-list';
import { HeaderImages } from './header-images';

const WrapperHeight = 180;

interface ThemeConfigurationProps {
  formTemplate: FormTemplate;
}
const Wrapper = styled.div`
  height: calc(100% - ${WrapperHeight}px);
  overflow: scroll;
  padding-bottom: 120px;
`;

export const ThemesConfiguration: FC<ThemeConfigurationProps> = ({
  formTemplate,
}) => {
  return (
    <Wrapper>
      <HeaderImages
        formTheme={formTemplate.formTheme}
        templateId={formTemplate.templateId}
      />
      <ColorThemesList
        formTheme={formTemplate.formTheme}
        templateId={formTemplate.templateId}
      />
      <BackgroundImage
        formTheme={formTemplate.formTheme}
        templateId={formTemplate.templateId}
      />
    </Wrapper>
  );
};
